module.exports = __webpack_public_path__ + "img/service-14.41bd1951.gif";